// extracted by mini-css-extract-plugin
export default {"authoringWrapper":"NotificationBox_authoringWrapper__0FGcY"};